import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { IProcurementApi } from './base';
import {
  ProcurementFilterRequest,
  ProcurementSaveFavoriteRequest,
  GetItemsBySupplierRequest,
  GetItemsByStatusRequest,
  ChangeStatusItemsRequest as ChangeStatusItemsRequest,
  ProcurementProcessStatusRequest,
  GetAuditRequest,
  GetImagePartRequest,
  EditProcurementItemPriceRequest,
  ProcurementProcessStatusBulkRequest,
  OrderPrintRequest,
  RequotePartProcurementRequest,
  GetRequoteProcurementItemsRequest,
  GetPartsToReassignToBodyShopRequest,
  BulkReassignProcurementRequest,
  GetSuppliersToEvaluate,
  GetAuditByClaimRequest,
  GetBulkChangeItemsByClaimRequest,
  GetItemsBySupplierAllClaimRequest,
  PartsCancelledSearchRequest,
  ReassignPartsCancelledRequest,
  GetReassignItemsFilterRequest
} from '../models/request';
import {
  GetAuditResponse,
  GetImagePartResponse,
  GetDetailsProcurementItemPriceResponse,
  GetItemsByStatusResponse,
  GetItemsBySupplierResponse,
  ManageStatusItemsResponse as ChangeStatusItemsResponse,
  ProcurementHeaderViewOrderResponse,
  ProcurementViewOrderMainResponse,
  ReasignProcurementResponse,
  GetBulkChangeItemsResponse,
  OrderPrintResponse,
  RequoteProcurementResponse,
  ProcurementReassignToBodyShopResponse,
  SuppliersToEvaluateResponse,
  GetAuditByClaimResponse,
  PartsCancelledSearchResponse,
  GetItemsCancelledBySupplierResponse,
  ReassignBodyshopProcurementSupplierItemsResponse,
  GetReassignItemsResponse,
  ReassignProcurementHeaderResponse
} from '../models/response';
import { PaginationResponse } from '../models/common/paginationResponse';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';
import { isNullUndefined } from '../services/utils';

const baseRoute: string = 'Procurement';

export class ProcurementApi extends IProcurementApi {
  getBulkChangeItemsByClaim(
    request: GetBulkChangeItemsByClaimRequest
  ): Promise<AxiosResponse<Result<GetBulkChangeItemsResponse[]>>> {
    return api.get(`${baseRoute}/GetBulkChangeItemsByClaim`, {
      params: request
    });
  }
  getHeaderViewOrder(
    request: ProcurementFilterRequest
  ): Promise<AxiosResponse<Result<ProcurementHeaderViewOrderResponse>, any>> {
    return api.get(`${baseRoute}/getheadervieworder`, { params: request });
  }
  getViewOrder(
    request: ProcurementFilterRequest
  ): Promise<AxiosResponse<Result<ProcurementViewOrderMainResponse>, any>> {
    return api.get(`${baseRoute}/getvieworder`, { params: request });
  }
  saveFavorite(
    request: ProcurementSaveFavoriteRequest
  ): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(`${baseRoute}/saveFavorite`, request);
  }
  getItemsBySupplier(
    request: GetItemsBySupplierRequest
  ): Promise<
    AxiosResponse<PaginationResponse<GetItemsBySupplierResponse>, any>
  > {
    return api.get(`${baseRoute}/getitemsbysupplier`, { params: request });
  }
  getItemsSupplierAllClaim(
    request: GetItemsBySupplierAllClaimRequest
  ): Promise<
    AxiosResponse<PaginationResponse<GetItemsBySupplierResponse[]>, any>
  > {
    return api.get(`${baseRoute}/getitemsbysupplierallclaim`, {
      params: request
    });
  }
  getItemsByStatus(
    request: GetItemsByStatusRequest
  ): Promise<AxiosResponse<Result<GetItemsByStatusResponse[]>>> {
    return api.get(`${baseRoute}/getitemsbystatus`, { params: request });
  }
  changeStatusItems(
    request: ChangeStatusItemsRequest,
    files: File[]
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    const formData = new FormData();

    files?.forEach(file => {
      formData.append('files', file);
    });
    formData.append(
      'changeStatusItemsRequest.guidProcurement',
      request.guidProcurement
    );
    formData.append(
      'changeStatusItemsRequest.guidProcurementSupplier',
      request.guidProcurementSupplier
    );
    formData.append(
      'changeStatusItemsRequest.idProcurementStatusCompanyNext',
      String(request.idProcurementStatusCompanyNext)
    );
    if (!isNullUndefined(request.shippingName)) {
      formData.append(
        'changeStatusItemsRequest.shippingName',
        request.shippingName
      );
    }

    if (!isNullUndefined(request.trackingCode)) {
      formData.append(
        'changeStatusItemsRequest.trackingCode',
        request.trackingCode
      );
    }

    request.procurementSupplierItems?.forEach((item, index) => {
      formData.append(
        `changeStatusItemsRequest.procurementSupplierItems[${index}].guidProcurementSupplierItem`,
        item.guidProcurementSupplierItem
      );
      formData.append(
        `changeStatusItemsRequest.procurementSupplierItems[${index}].idProcurementStatusCompany`,
        String(item.idProcurementStatusCompany)
      );
    });

    return api.put(`${baseRoute}/changestatusitems`, formData, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  processCancelStatus(
    request: ProcurementProcessStatusRequest
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    return api.put(`${baseRoute}/processCancelStatus`, request, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }
  processReturnStatus(
    request: ProcurementProcessStatusRequest
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    return api.put(`${baseRoute}/processReturnStatus`, request, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }
  getQuoteAuditData(
    request: GetAuditRequest
  ): Promise<AxiosResponse<Result<GetAuditResponse[]>>> {
    return api.get(`${baseRoute}/getquoteauditdata`, { params: request });
  }
  getQuoteAuditDataByClaim(
    request: GetAuditByClaimRequest
  ): Promise<AxiosResponse<Result<GetAuditByClaimResponse[]>>> {
    return api.get(`${baseRoute}/getquoteauditdatabyclaim`, {
      params: request
    });
  }
  getImagePart(
    request: GetImagePartRequest
  ): Promise<AxiosResponse<Result<GetImagePartResponse[]>, any>> {
    return api.get(`${baseRoute}/getimagepart`, { params: request });
  }
  editProcurementItemPrice(
    request: EditProcurementItemPriceRequest
  ): Promise<AxiosResponse<Result<undefined>>> {
    return api.put(`${baseRoute}/editprocurementitemprice`, request);
  }
  getDetailsProcurementItemPrice(
    guidProcurementSupplierItem: string
  ): Promise<AxiosResponse<Result<GetDetailsProcurementItemPriceResponse>>> {
    return api.get(`${baseRoute}/getdetailsprocurementitemprice`, {
      params: { guidProcurementSupplierItem: guidProcurementSupplierItem }
    });
  }
  getBulkChangeItems(
    procurementGuid: string,
    requestedStatus: string
  ): Promise<AxiosResponse<Result<GetBulkChangeItemsResponse>>> {
    return api.get(`${baseRoute}/GetBulkChangeItems`, {
      params: {
        procurementGuid: procurementGuid,
        requestedStatus: requestedStatus
      }
    });
  }
  cancelBulkItems(
    request: ProcurementProcessStatusBulkRequest[]
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    return api.put(`${baseRoute}/cancelBulkItems`, request, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }
  returnBulkItems(
    request: ProcurementProcessStatusBulkRequest[]
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    return api.put(`${baseRoute}/returnBulkItems`, request, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }
  getReassignItems(
    request: GetReassignItemsFilterRequest
  ): Promise<AxiosResponse<Result<GetReassignItemsResponse>>> {
    return api.post(`${baseRoute}/GetReassignItems`, request, {
      timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
    });
  }
  getReassignHeader(
    guidProcurement: string | null,
    guidClaim: string | null
  ): Promise<AxiosResponse<Result<ReassignProcurementHeaderResponse>>> {
    return api.get(`${baseRoute}/GetReassignHeader`, {
      params: { guidProcurement, guidClaim }
    });
  }
  orderPrint(
    request: OrderPrintRequest
  ): Promise<AxiosResponse<Result<OrderPrintResponse>, any>> {
    return api.get(`${baseRoute}/orderprint`, {
      params: request
    });
  }
  requotePartProcurement(
    request: RequotePartProcurementRequest
  ): Promise<AxiosResponse<Result<any>>> {
    return api.post(`${baseRoute}/requotepartprocurement`, request);
  }
  getRequoteProcurementItems(
    request: GetRequoteProcurementItemsRequest
  ): Promise<AxiosResponse<Result<RequoteProcurementResponse>>> {
    return api.get(`${baseRoute}/getrequoteprocurementitems`, {
      params: request
    });
  }
  getPartsToReassignToBodyShop(
    request: GetPartsToReassignToBodyShopRequest
  ): Promise<AxiosResponse<Result<ProcurementReassignToBodyShopResponse[]>>> {
    return api.post(`${baseRoute}/getpartstoreassigntobodyshop`, request);
  }
  reassignToBodyShop(
    request: BulkReassignProcurementRequest
  ): Promise<AxiosResponse<Result<ReasignProcurementResponse>, any>> {
    return api.put(`${baseRoute}/reassigntobodyshop`, request, {
      timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
    });
  }
  getSuppliersToEvaluate(
    request: GetSuppliersToEvaluate
  ): Promise<AxiosResponse<Result<SuppliersToEvaluateResponse[]>>> {
    return api.get(`${baseRoute}/getsupplierstoevaluate`, {
      params: request
    });
  }
  reopenPart(
    guidProcurementSupplierItem: string
  ): Promise<AxiosResponse<Result<ChangeStatusItemsResponse>>> {
    const url = `${baseRoute}/reopenPart?guidProcurementSupplierItem=${guidProcurementSupplierItem}`;
    return api.put(url);
  }

  getPartsCancelled(
    request: PartsCancelledSearchRequest
  ): Promise<AxiosResponse<PaginationResponse<PartsCancelledSearchResponse>>> {
    return api.post(`${baseRoute}/searchgriditemscancelledbysupplier`, request);
  }

  getItemsCancelledBySupplierDetails(
    procurementSupplierItemGuids: string[]
  ): Promise<AxiosResponse<Result<GetItemsCancelledBySupplierResponse[]>>> {
    return api.post(`${baseRoute}/getitemscancelledbysupplierdetail`, {
      procurementSupplierItemGuids
    });
  }

  reassignPartsCancelledBySupplier(
    request: ReassignPartsCancelledRequest[]
  ): Promise<AxiosResponse<Result<boolean>>> {
    return api.put(`${baseRoute}/ReassignProcurementSupplierItems`, request, {
      timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
    });
  }

  reassignToBodyshopProcurementSupplierItems(
    request: ReassignPartsCancelledRequest[]
  ): Promise<
    AxiosResponse<Result<ReassignBodyshopProcurementSupplierItemsResponse>>
  > {
    return api.put(
      `${baseRoute}/ReassignToBodyShopProcurementSupplierItems`,
      request,
      {
        timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
      }
    );
  }
}
